import { cn } from "@/shared/utils/general/cn"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

/**
 * Wrapper for rendering real icon components in skeleton-muted color.
 *
 * Uses `.skeleton-icon` utility (defined in globals.css) to force
 * all descendant SVGs to `var(--muted)` — matching `<Skeleton>` bars.
 */
function SkeletonIcon({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <span className={cn("skeleton-icon animate-pulse", className)}>
      {children}
    </span>
  )
}

export { Skeleton, SkeletonIcon }
